import { Component, Inject, OnInit, Optional } from '@angular/core';
import { Observable, forkJoin, map, startWith } from 'rxjs';
import { TemplateMasterService } from '../../../template-master.service';
import { FormControl } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-category-selection-template',
  templateUrl: './category-selection-template.component.html',
  styleUrls: ['./category-selection-template.component.scss']
})
export class CategorySelectionTemplateComponent implements OnInit {

  filteredOptions!: Observable<any[]>;
  myControl = new FormControl();
  allTypes: any[] = [];

  ecomFilteredOptions!: Observable<any[]>;
  ecomMyControl = new FormControl();
  ecomIndustry: any[] = [];

  templateName: any = '';
  desc: any = '';
  websiteType: 'STATIC' | 'E_COMMERCE' = 'STATIC';
  bType: any = null;
  templateCategory: any = '';
  submitLoader: boolean = false;
  templateGeneration: boolean = false;
  editTempData: any = {};
  subCategoryId: string = '';

  constructor(
    private _templateService: TemplateMasterService,
    private snackbar: MatSnackBar,
    public dialogRef: MatDialogRef<CategorySelectionTemplateComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  ngOnInit(): void {
    // this.getAllTypes();
    this.getAllIndustries();

    if (this.data?.edit) {
      this.websiteType = this.data?.data?.type || 'STATIC';
      this.templateName = this.data?.data?.name || '';
      this.desc = this.data?.data?.desc || '';
      this.bType = this.data?.data?.type || null;
      this.templateCategory = this.data?.data?.templateCategory || '';
    }
  }

  getAllIndustries(): void {
  forkJoin({
    industries: this._templateService.mergedIndustrySubIndustry(),
    ecommerce: this._templateService.getAllEcommerceIndustries()
  }).subscribe({
    next: ({ industries, ecommerce }: any) => {

      const industryData = (industries?.data || []).map((data: any) => {
        return ({
          // name: `${data?.parent?.name} - ${data.name}`,
          name: `${data.name}`,
          industryId: data?.parent?.id,
          subIndustryId: data.id,
          industryName: data?.parent?.name,
          subIndustryName: data.name,
          source: 'industry'
        });
      });

      const ecommerceData = (ecommerce?.data || []).map((data: any) => ({
        // name: `${data?.parent?.name} - ${data.name}`,
        name: `${data.name}`,
        industryId: data?.parent?.id,
        subIndustryId: data.id,
        industryName: data?.parent?.name,
        subIndustryName: data.name,
        source: 'ecommerce'
      }));

      // Merge both arrays
      this.allTypes = [...industryData, ...ecommerceData];

      // Optional: remove duplicates by subIndustryId
      this.allTypes = Array.from(
        new Map(
          this.allTypes.map(item => [item.subIndustryId, item])
        ).values()
      );

      this.filteredOptions = this.myControl.valueChanges.pipe(
        startWith(''),
        map(value => this._filter(value))
      );
    },
    error: (err) => {
      this.snackbar.open(
        err?.error?.message || 'Failed to load data',
        'Close',
        { duration: 2000 }
      );
    }
  });
}

private _filter(value: string): any[] {
  const filterValue = (value || '').toLowerCase();

  return this.allTypes.filter(item =>
    item.name.toLowerCase().includes(filterValue) ||
    // item.industryName.toLowerCase().includes(filterValue) ||
    item.subIndustryName.toLowerCase().includes(filterValue)
  );
}

  /**  Get Static Industries */
  getAllTypes(): void {
    this._templateService.mergedIndustrySubIndustry().subscribe({
      next: (res: any) => {
        // console.log(res.data)
        if (!res?.data) return;
        this.allTypes = res.data.map((data: any) => ({
          name: `${data?.parent?.name} - ${data.name}`,
          industryId: data?.parent?.id,
          subIndustryId: data.id,
          industryName: data?.parent?.name,
          subIndustryName: data.name,
        }));

        this.filteredOptions = this.myControl.valueChanges.pipe(
          startWith(''),
          map(value => this._filter(value))
        );

        this.getEcommerceIndustry();
      },
      error: (err) => {
        this.snackbar.open(err?.error?.message || 'Failed to load industries', 'Close', {
          duration: 2000,
        });
      }
    });
  }

  // private _filter(value: string): any[] {
  //   const filterValue = value?.toLowerCase() || '';
  //   return this.allTypes.filter(option =>
  //     option.name.toLowerCase().includes(filterValue)
  //   );
  // }

  /**  Get E-Commerce Industries */
  getEcommerceIndustry(): void {
    this._templateService.getAllEcommerceIndustries().subscribe({
      next: (res: any) => {
        // if (!res?.data) return;
        this.ecomIndustry = res.data.map((data: any) => ({
          name: data.name ?? "",
          industryId: data.parent?.id ?? "",
          subIndustryId: data.id ?? "",
          industryName: data.parent?.name ?? "",
          subIndustryName: data.name ?? "",
        }));
        this.ecomFilteredOptions = this.ecomMyControl.valueChanges.pipe(
          startWith(''),
          map(value => this._ecomFilter(value))
        );
      },
      error: (err) => {
        this.snackbar.open(err?.error?.message || 'Failed to load e-commerce data', 'Close', {
          duration: 2000,
        });
      }
    });
  }

  private _ecomFilter(value: string): any[] {
    const filterValue = value?.toLowerCase() || '';
    return this.ecomIndustry.filter(option =>
      option.name.toLowerCase().includes(filterValue)
    );
  }

  selectBusinessType(ev: any): void {
    this.bType = ev;
  }

  getVal(ev: any): void {
    if (!ev || ev.length === 0) {
      this.bType = null;
    }
  }

  close(): void {
    this.dialogRef.close({ data: null });
  }

  /**  Submit manually */
  submit(): void {
    if (this.bType && this.templateName && this.desc) {
      this.dialogRef.close({
        data: {
          bType: this.bType,
          tempName: this.templateName,
          websiteType: this.websiteType,
          approvalStatus: '',
          desc: this.desc,
        },
      });
    } else {
      this.snackbar.open('Please fill mandatory fields to proceed', 'Ok', {
        duration: 1500,
      });
    }
  }

  /**  Edit Template */
  editTemplate(): void {
    this.editTempData = {
      id: this.data?.data?.id,
      name: this.templateName,
      desc: this.desc,
      type: this.websiteType,
      screenShot:
        'https://upload.wikimedia.org/wikipedia/commons/a/a3/Image-not-found.png?20210521171500',
      // templateCategory: this.templateCategory,
      approvalStatus: 'PENDING',
      subIndustry: {
        id: this.data?.data?.subIndustry?.id,
        name: this.data?.data?.subIndustry?.name,
      },
    };

    this._templateService.updateTemplate(this.editTempData).subscribe({
      next: () => {
        this.snackbar.open('Template Updated', 'close', { duration: 2000 });
        this.dialogRef.close({
          data: {
            bType: this.bType,
            tempName: this.templateName,
            id: this.data?.data?.id,
            websiteType: this.websiteType,
            approvalStatus: 'PENDING',
            desc: this.desc,
            subIndustry: this.data?.data?.subIndustry,
          },
        });
      },
      error: (err) => {
        this.snackbar.open(err?.error?.message || 'Failed to update template', 'Close', {
          duration: 2000,
        });
      }
    });
  }

  /**  Generate Template with AI */
  templateAutoGenerate(): void {
    if (!this.bType || !this.templateName || !this.desc) {
      this.snackbar.open('Please fill all mandatory fields before generating.', 'Close', {
        duration: 2000,
      });
      return;
    }

    this.templateGeneration = true;
    const payload = {
      industry_id: this.bType.subIndustryId,
      industry: this.bType.subIndustryName,
      name: this.templateName.trim(),
      business_desc: this.desc.trim(),
      step: 'WEBSITE',
    };

    console.log(' Sending AI Template Payload:', payload);

    this._templateService.generateTemplateByAI(payload).subscribe({
      next: (res: any) => {
        console.log(' AI Template Generated:', res);
        this.snackbar.open('Template generated successfully!', 'Close', { duration: 2000 });
        this.dialogRef.close({
          data: { tempGenerated: true, newTemplate: res?.data || null }
        });
        this.templateGeneration = false;
      },
      error: (err) => {
        console.error('❌ AI Generation Error:', err);
        this.snackbar.open(err?.error?.message || 'Failed to generate template.', 'Close', {
          duration: 2500,
        });
        this.templateGeneration = false;
      }
    });
  }

  /**  Description max length validation */
  checkDescriptionLength(): void {
    if (this.desc && this.desc.length > 500) {
      this.desc = this.desc.slice(0, 500);
      this.snackbar.open('Description cannot exceed 500 characters.', 'Close', {
        duration: 2000,
      });
    }
  }

  /** Template Name max length validation */
  checkTemplateNameLength(): void {
    if (this.templateName && this.templateName.length > 100) {
      this.templateName = this.templateName.slice(0, 100);
      this.snackbar.open('Template Name cannot exceed 100 characters.', 'Close', {
        duration: 2000,
      });
    }
  }
}
